import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { httpInterceptors } from './core/config/http-interceptors';
import { CognitoAuthService } from './shared/service/cognito-auth.service';
import { appRoutes } from './app.routes';
import { AUTH_PROVIDER } from './shared/common/injector-token';
import { TranslateModule } from '@ngx-translate/core';
import { provideMarkdown } from 'ngx-markdown';
import { TranslateConfig } from './core/config/translate.config';
import {
  provideStore,
  Store,
  withNgxsNoopExecutionStrategy,
} from '@ngxs/store';
import {
  ngxsConfig,
  ngxsStates,
  ngxsStorageConfig,
} from './core/config/ngxs.config';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import en from '@angular/common/locales/en-GB';
import de from '@angular/common/locales/de';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { DynamicLocaleId } from './shared/common/dynamic-locale-id';

import { defineLocale } from 'ngx-bootstrap/chronos';
import {
  BsDatepickerConfig,
  BsDatepickerModule,
  BsDaterangepickerConfig,
} from 'ngx-bootstrap/datepicker';
import { deLocale, enGbLocale, esLocale } from 'ngx-bootstrap/locale';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { provideToastr } from 'ngx-toastr';
import { provideIcons } from '@ng-icons/core';
import { APP_ICONS } from './core/config/icons.config';

registerLocaleData(en, 'en');
registerLocaleData(de, 'de');
registerLocaleData(es, 'es');
defineLocale('en-gb', enGbLocale);
defineLocale('de', deLocale);
defineLocale('es', esLocale);

const authProviderClass = CognitoAuthService;

const globalServices = [
  { provide: AUTH_PROVIDER, useExisting: authProviderClass },
  { provide: LOCALE_ID, useClass: DynamicLocaleId, deps: [Store] },
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' })
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    TranslateModule.forRoot(TranslateConfig).providers!,
    provideStore(
      ngxsStates,
      ngxsConfig,
      withNgxsNoopExecutionStrategy(),
      withNgxsStoragePlugin(ngxsStorageConfig),
      withNgxsRouterPlugin()
    ),
    provideToastr({
      positionClass: 'toast-bottom-right',
      timeOut: 3000,
      progressBar: true,
      closeButton: true,
      preventDuplicates: true,
    }),
    provideIcons(APP_ICONS),
    provideMarkdown(),
    // ngx-bootstrap
    importProvidersFrom(ModalModule, BsDatepickerModule, ProgressbarModule),
    ...httpInterceptors,
    ...globalServices,
  ],
};
